<template>
    <c-model
        ref="credentials"
        @confirm="confirm"
        width="40%"
        class="credentials"
        title="准考证信息"
    >
        <div>
            <c-credentials-template
                :note="note"
                :show-type="data.showType"
                :data="data"
            />
            <c-credentials-template
                :print="true"
                ref="printBox"
                :note="note"
                :show-type="data.showType"
                :data="data"
            />
        </div>

        <template slot="otherBtn">
            <el-tooltip
                effect="dark"
                content="如无法打印,请使用谷歌浏览器打印"
                placement="top"
            >
                <a @click="printCredentials" class="btn btn-save">打印准考证</a>
            </el-tooltip>
        </template>
    </c-model>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            default: () => {},
        },
        note: {
            type: String,
            default: '',
        },
    },
    data() {
        return {};
    },
    methods: {
        open() {
            this.$refs.credentials.open();
        },
        printCredentials() {
            // this.$alert("为保证打印质量,打印时请选择横向打印", "提示!", {
            //   confirmButtonText: "确定",
            //   type: "warning",
            //   showClose: false,
            //   callback: action => {
            //     //显示下面的签名信息
            //     setTimeout(() => {
            //       this.$print(this.$refs.printBox);
            //     }, 200);
            //   }
            // });
            //显示下面的签名信息
            setTimeout(() => {
                this.$print(this.$refs.printBox);
            }, 200);
        },
        confirm() {
            this.$refs.credentials.close();
        },
    },
};
</script>

<style lang="scss" module="$">
.main {
    display: flex;
    justify-content: space-between;
}
.info {
    flex-basis: 500px;
    flex-grow: 0;
    flex-shrink: 0;
}
.row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    & > div {
        flex-grow: 0;
        flex-basis: 50%;
    }
}
.flex_row {
    display: flex;
    justify-content: space-between;
    flex: 1;
    margin-bottom: 20px;
}
.flex_row_photo {
    flex-basis: 150px;
    flex-grow: 0;
}
.title {
    text-align: center;
    margin-top: 0;
}
.photo_wrap {
    border: 1px solid #eee;
    display: block;
    height: inherit;
    width: 100%;
    min-height: 131px;
    max-height: 165px;
    & > img {
        width: 100%;
        height: 100%;
    }
}
.tips {
    & span {
        font-weight: bold;
        font-size: 13px;
        display: inline-block;
        margin-bottom: 5px;
    }
}
</style>
